import axios from 'axios';
import { toast } from 'react-toastify';
import { getBaseUrl } from './baseUrlService';

const apiRequest = axios.create({
  // withCredentials: true,
  baseURL: getBaseUrl(),
});
console.log('🚀 ~ Active Base URL:', getBaseUrl());

apiRequest.interceptors.response.use(
  response => response,
  error => {
    console.log(error, 'this error from interseptor');
    if (error?.status === 401) {
      toast.error('Session expired please login again');
      if (import.meta.env.VITE_ENV !== 'development') {
        window.location.replace('/');
        return;
      }
    }
    return Promise.reject(error);
  }
);

export default apiRequest;
